import { Account } from '.';
import { AccountOrganization } from './organization.model';
import { UserSkill } from './skill.model';

export enum VISIBILITY_TYPE {
  PUBLIC = 'Public',
  FAM = 'Fam',
}

export interface CreateCredPayload {
  description: string;
  resourceIds: string[];
  visibility: VISIBILITY_TYPE;
}

export type JsonObject = {
  [key: string]: unknown;
};

export type MediaType = 'photo' | 'video' | 'gif' | 'unknown';

export class FeedResource {
  externalId: string;
  id: string;
  type: MediaType;
  url: string;

  static getMediaType(URL = ''): MediaType {
    const url = URL.toLowerCase();
    if (['.gif'].some(ext => url.includes(ext))) {
      return 'gif';
    }
    if (['.jpg', '.jpeg', '.png'].some(ext => url.includes(ext))) {
      return 'photo';
    }
    if (['.mp4', '.quicktime', '.mov'].some(ext => url.includes(ext))) {
      return 'video';
    }
    return 'unknown';
  }

  constructor(json: any) {
    this.externalId = json.externalId;
    this.id = json._id || json.id;
    this.type = FeedResource.getMediaType(json.url);
    this.url = json.url;
  }
}
export class Cred {
  collaborators: Account[];
  description: string;
  createdAt?: Date;
  createdBy: Account;
  id: string;
  isDeleted?: boolean;
  isArchived: boolean;
  isReccoReal?: boolean;
  hashtags: string[];
  hifiCount: number = 0;
  commentCount: number = 0;
  shareCount: number = 0;
  reccoCount: number = 0;
  resources: FeedResource[];
  updatedAt?: Date;
  visibility: VISIBILITY_TYPE;
  skills?: UserSkill[];
  organizations?: AccountOrganization[];

  constructor(json: any) {
    this.collaborators = json.collaborators?.map((clb: any) => new Account(clb));
    this.description = json.description;
    this.createdAt = json.createdAt && new Date(json.createdAt);
    this.createdBy = json.createdBy && new Account(json.createdBy);
    this.collaborators = json.collaborators?.map((collaborator: any) => new Account(collaborator));
    this.id = json.id || json._id;
    this.hashtags = json.hashtags;
    this.resources = json.resources?.map((resource: any) => new FeedResource(resource));
    this.visibility = json.visibility;
    this.updatedAt = json.updatedAt && new Date(json.updatedAt);
    this.isDeleted = json.isDeleted;
    this.isArchived = json.isArchived;
    this.commentCount = json.commentCount;
    this.hifiCount = json.hifiCount;
    this.shareCount = json.shareCount;
    this.reccoCount = json.reccoCount;
    this.skills = json.skills && json.skills?.map((skill: UserSkill) => new UserSkill(skill));
    this.organizations = json.organizations && json.organizations?.map((org: AccountOrganization) => new AccountOrganization(org));
    this.isReccoReal = json.isReccoReal;
  }
}
